import { ISearchBoxProps, SearchBox } from "@fluentui/react";
import { SEARCHBOX_STYLES } from "../../ReportCatalog.common";

export const SearchInputFilter = ({ onChange }: ISearchBoxProps) => (
  <SearchBox styles={SEARCHBOX_STYLES} placeholder="Search" onChange={onChange} disableAnimation />
);
